import { createSelector } from '@ngrx/store';
import { applicationFeatures } from '../reducers';

export const { selectDirectory: selectDirectoryState } = applicationFeatures;
export const selectModbusTable = createSelector(selectDirectoryState, (state) => state.modbusTable);
export const selectModemRadioBands = createSelector(selectDirectoryState, (state) => state.modemRadioBands);
export const selectEnergyModes = createSelector(selectDirectoryState, (state) => state.energyModes);
